var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('navbar'),_vm._v(" "),_c('hero'),_vm._v(" "),_c('introduction'),_vm._v(" "),_c('process'),_vm._v(" "),_c('team'),_vm._v(" "),_c('contact')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }